var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoProject(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 111.434,
    height: 116.201,
    viewBox: "0 0 111.434 116.201",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(-1271.269 -402.33)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2-2",
    "data-name": "Group 2",
    transform: "translate(1288.854 402.33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M229.673,343.187l-6.892,6.892a4.373,4.373,0,0,0-1.28,3.091v27.807a4.372,4.372,0,0,0,4.372,4.372h53.8a4.372,4.372,0,0,0,4.372-4.372V353.17a4.373,4.373,0,0,0-1.28-3.091l-6.892-6.892,6.866-6.866a23.431,23.431,0,0,0,0-33.137l-.021-.021a23.327,23.327,0,0,0-29.946-2.563,23.327,23.327,0,0,0-29.946,2.563l-.021.021a23.431,23.431,0,0,0,0,33.137l6.866,6.866Zm40.02,6.182L255.866,363.2a4.373,4.373,0,0,1-6.183,0l-13.827-13.828-5.612,5.612v21.625h45.061V354.981l-5.612-5.612Zm-27.655-6.182,10.736,10.736,10.736-10.736L252.774,332.45l-10.736,10.737ZM269.693,337l6.866-6.866a14.689,14.689,0,0,0,0-20.773l-.021-.021a14.583,14.583,0,0,0-20.624,0h0a4.374,4.374,0,0,1-6.278,0h0a14.583,14.583,0,0,0-20.624,0l-.021.021a14.688,14.688,0,0,0,0,20.772L235.856,337l13.827-13.828a4.372,4.372,0,0,1,6.183,0L269.693,337Z",
    transform: "translate(-215.944 -296.33)",
    fill: "#ae0721",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(1320.586 437.703)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M283.926,401.738a6.674,6.674,0,0,0,9.438,0l22.995-23a.062.062,0,0,1,.088,0L340.4,402.7a3.306,3.306,0,0,0,4.675-4.675l-23.954-23.953a6.673,6.673,0,0,0-9.293-.14h0l-23.14,23.135a.062.062,0,0,1-.088,0",
    transform: "translate(-283.926 -372.113)",
    fill: "#ae0721",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(1271.269 437.703)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M235.711,397.063a.063.063,0,0,1-.088,0l-23.139-23.135h0a6.674,6.674,0,0,0-9.294.14l-23.953,23.953a3.306,3.306,0,0,0,4.675,4.675l23.953-23.953a.063.063,0,0,1,.088,0l22.995,23c1.251,1.252-.615.529,1.155.529a6.676,6.676,0,0,0,4.719-1.955",
    transform: "translate(-178.269 -372.113)",
    fill: "#ae0721",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(1307.711 473.701)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M258.749,449.3h.445l2.406,5.34h-1.056l-.362-.822H257.76l-.354.822h-1.064Zm1.093,3.726-.867-1.991-.875,1.991Z",
    transform: "translate(-256.342 -449.272)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M269.1,449.432h2.1a1.828,1.828,0,1,1,0,3.636h-1.131v1.644H269.1Zm2.029,2.8c.747,0,1.109-.415,1.109-.973s-.362-.958-1.109-.958h-1.056v1.931Z",
    transform: "translate(-263.146 -449.341)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M283.833,449.432h.973v2.18h2.52v-2.18h.973v5.28h-.973V452.5h-2.52v2.21h-.973Z",
    transform: "translate(-271.001 -449.341)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M295.559,451.968a2.753,2.753,0,1,1,2.753,2.731A2.684,2.684,0,0,1,295.559,451.968Zm4.526,0a1.774,1.774,0,1,0-1.773,1.833A1.78,1.78,0,0,0,300.085,451.968Z",
    transform: "translate(-277.254 -449.237)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M309.514,449.415h.422l2.233,3.266,2.225-3.266h.43V454.7h-.95v-3.1l-1.629,2.406H312.1l-1.644-2.406v3.1h-.943Z",
    transform: "translate(-284.695 -449.332)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M323.565,449.432H327.3v.882h-2.76v1.3h2.467v.875h-2.467v1.343h2.836v.882h-3.81Z",
    transform: "translate(-292.188 -449.341)",
    fill: "#1a1818"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(1275.011 496.779)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M274.5,500.206h-2.2v-1.527h6.083v1.527h-2.2v5.7H274.5Z",
    transform: "translate(-232.15 -498.679)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M287.159,498.679h1.677v2.848h2.954v-2.848h1.678V505.9H291.79v-2.848h-2.954V505.9h-1.677Z",
    transform: "translate(-240.075 -498.679)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M304.07,498.679h5.238v1.507h-3.561v1.352h3.139v1.486h-3.139V504.4h3.664V505.9H304.07Z",
    transform: "translate(-249.093 -498.679)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M188.678,527v5.657h-2.392v-10.68h.572l6.257,5.9V522.1h2.392v10.68h-.572Z",
    transform: "translate(-186.286 -511.103)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M211,522.238h7.656v2.2h-5.2v1.976h4.588v2.173h-4.588V530.6h5.355v2.2H211Z",
    transform: "translate(-199.464 -511.242)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M231.589,522.238h2.452V532.8h-2.452Z",
    transform: "translate(-210.443 -511.242)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M241,527.294a5.3,5.3,0,0,1,5.55-5.476,5.461,5.461,0,0,1,4.5,2.112l-1.73,1.493a3.2,3.2,0,0,0-2.693-1.342,2.981,2.981,0,0,0-3.144,3.183,3.067,3.067,0,0,0,3.129,3.3,2.4,2.4,0,0,0,2.662-2.157h-3.023v-2.1h5.325a4.128,4.128,0,0,1,.181,1.357,4.883,4.883,0,0,1-5.22,5.1A5.271,5.271,0,0,1,241,527.294Z",
    transform: "translate(-215.46 -511.018)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M267.708,522.238h2.452V526.4h4.317v-4.164h2.452V532.8h-2.452v-4.164H270.16V532.8h-2.452Z",
    transform: "translate(-229.703 -511.242)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M292.422,522.238h4.8c2.016,0,3.1,1.086,3.1,2.685a2.55,2.55,0,0,1-1.309,2.368v.06a2.313,2.313,0,0,1,1.79,2.414c0,1.78-1.2,3.032-3.49,3.032h-4.889Zm4.242,4.194c.722,0,1.2-.377,1.2-1.071s-.466-1.011-1.188-1.011h-1.805v2.082Zm.346,4.254c.842,0,1.339-.422,1.339-1.116s-.481-1.086-1.324-1.086h-2.151v2.2Z",
    transform: "translate(-242.882 -511.242)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M312.754,527.294a5.566,5.566,0,1,1,5.566,5.476A5.39,5.39,0,0,1,312.754,527.294Zm8.664,0a3.1,3.1,0,1,0-3.1,3.213A3.1,3.1,0,0,0,321.418,527.294Z",
    transform: "translate(-253.723 -511.018)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M339.788,528.423v-6.185h2.452v6.155c0,1.418.707,2.368,2.136,2.368s2.136-.95,2.136-2.368v-6.155h2.452v6.185a4.588,4.588,0,0,1-9.176,0Z",
    transform: "translate(-268.139 -511.242)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M364.244,522.238h4.588c2.512,0,4,1.252,4,3.409a3.234,3.234,0,0,1-2.392,3.2l3.009,3.876v.076h-2.768l-2.151-2.911a1.405,1.405,0,0,0-1.429-.739H366.7V532.8h-2.452Zm4.423,4.872c1.023,0,1.685-.528,1.685-1.342s-.662-1.342-1.685-1.342H366.7v2.685Z",
    transform: "translate(-281.18 -511.242)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M385.252,531.306l1.339-1.916a5.087,5.087,0,0,0,3.159,1.131c.8,0,1.459-.226,1.459-.875,0-.483-.346-.724-1.474-1.056l-.782-.241c-2.227-.68-3.294-1.705-3.294-3.41,0-2.051,1.565-3.123,3.9-3.123a6.237,6.237,0,0,1,3.881,1.222l-1.369,1.855a4.1,4.1,0,0,0-2.542-.829c-.8,0-1.339.226-1.339.739,0,.558.767.83,2.136,1.313,2.512.89,3.415,1.75,3.415,3.364,0,2.006-1.369,3.273-4.077,3.273A6.918,6.918,0,0,1,385.252,531.306Z",
    transform: "translate(-292.382 -511.018)",
    fill: "#1a1818"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoProject);
export default __webpack_public_path__ + "static/media/logo-project.425650de5375316cc0c1063b2b20c17b.svg";
export { ForwardRef as ReactComponent };